<div class="row mb-4">
  <div class="col-12">
    <h4 class="module-title">{{ 'company.documents' | translate }}</h4>
  </div>
</div>
@if (campaignSlug == 'meridien-electron-energy-therapy-meet-live-pain-free-sleep-better') {
  <div class="row mb-4">
    <div class="col-12">
      <a
        class="tw-inline-block tw-rounded tw-border tw-border-primary tw-bg-white tw-px-3 tw-py-2 tw-text-center tw-text-primary hover:tw-bg-opacity-90"
        [href]="'https://drive.google.com/drive/folders/1JPnY5x8TGoR_aOQwp0Lm_YB0HUSmtCsQ'"
        target="_blank"
        rel="noopener"
      >
        Document Link</a
      >
    </div>
  </div>
}
<!-- Public documents -->
@if (campaignSlug !== 'meridien-electron-energy-therapy-meet-live-pain-free-sleep-better') {
  <div class="">
    @if (documentsTotal > 0) {
      <ul class="tw-grid tw-list-none tw-grid-cols-2 tw-gap-4 tw-pl-0 xl:tw-grid-cols-3">
        @for (document of documents; track document) {
          <li class="nav-item">
            <a
              class="tw-inline-block tw-h-full tw-w-full"
              [href]="document.url"
              target="_blank"
              rel="noopener"
              data-t="fileDownloadClick"
              [attr.data-file-name]="document.attachmentName"
              [attr.data-file-url]="document.url"
              [attr.data-file-ext]="document.attachmentName || document.url"
            >
              <ng-container
                *ngTemplateOutlet="
                  documentButton;
                  context: { name: document.attachmentName, url: document.url }
                "
              ></ng-container>
            </a>
          </li>
        }
      </ul>
    }
    @if (isDocumentLoading) {
      <agmo-loading></agmo-loading>
    }
    @if (!isDocumentLoading && documentsTotal == 0) {
      <app-empty-state [message]="'common.noDocument'"></app-empty-state>
    }
    @if (documentsTotal > documents.length) {
      <button
        type="button"
        class="tw-block tw-w-full tw-cursor-pointer tw-rounded tw-border tw-border-primary tw-bg-transparent tw-px-3 tw-py-2 tw-text-center tw-font-bold tw-text-primary hover:tw-border-opacity-50"
        (click)="handleLoadMoreDocuments()"
      >
        {{ 'common.loadMore' | translate }}
      </button>
    }
  </div>
}

<!-- For invested investor only -->
<div>
  @if (!isLoading && attachments.length > 0) {
    <div class="mb-5">
      <hr />
      <h5 class="tw-mb-4 tw-text-lg">{{ 'learn.for.shareholders' | translate }}</h5>
      <ul class="tw-grid tw-list-none tw-grid-cols-2 tw-gap-4 tw-pl-0 xl:tw-grid-cols-3">
        @for (document of attachments; track document) {
          <li class="nav-item">
            <a
              class="tw-inline-block tw-h-full tw-w-full"
              [href]="document.url"
              target="_blank"
              rel="noopener"
              data-t="fileDownloadClick"
              [attr.data-file-name]="document.attachmentName"
              [attr.data-file-url]="document.url"
              [attr.data-file-ext]="document.attachmentName || document.url"
            >
              <ng-container
                *ngTemplateOutlet="
                  documentButton;
                  context: { name: document.attachmentName, url: document.url }
                "
              ></ng-container>
            </a>
          </li>
        }
      </ul>
      @if (total - attachments.length > 0) {
        <div class="my-3">
          <div class="view-more" (click)="loadMore()">
            {{ 'common.loadMore' | translate }}
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-template #documentButton let-name="name" let-url="url">
  <div
    class="tw-flex tw-h-full tw-w-full tw-items-center tw-rounded tw-bg-divider tw-bg-opacity-50 tw-p-3 tw-text-sm tw-text-body hover:tw-bg-opacity-70 hover:tw-text-body-dark"
    data-t="fileDownloadClick"
    [attr.data-file-name]="name"
    [attr.data-file-url]="url"
    [attr.data-file-ext]="name || url"
  >
    <div class="pitchin-icon pitchin-icon-document tw-mr-2 tw-flex-none"></div>
    {{ name }}
  </div>
</ng-template>
